import { Input } from 'antd';
import React from 'react';
import classnames from 'classnames';

export default function TextArea({ value, onChange, limit, className, placeholder, disabled, id, rows }) {
  const _value = value ?? '';
  const _rows = rows ?? 5;

  const _onChange = (e) => {
    if (!limit) {
      return onChange(e.target.value);
    }

    return e.target.value.length <= limit && onChange(e.target.value);
  };

  return (
    <div className={className}>
      <Input.TextArea
        id={id}
        value={_value}
        onChange={_onChange}
        placeholder={placeholder}
        disabled={disabled}
        rows={_rows}
        style={{
          resize: 'none',
        }}
      />
      {limit && (
        <div className={classnames('flex justify-end mt-1', { 'text-brand-danger': _value.length === limit })}>
          {_value?.length}/{limit}
        </div>
      )}
    </div>
  );
}
